import { cloneDeep, isEmpty } from "lodash";
import { memo, useEffect, useState } from "react";
// import CommonBtn from "../../../../app/common-components/ui-components/Button/Index.js";
// import ButtonComponent from "../../../app/common-components/ButtonComponent.jsx";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CustomModal from "../../../../app/common-components/CustomModal.jsx";
import CustomSelectDropDown from "../../../../app/common-components/CustomSelectDropDown.jsx";
// import AlertBox from "../../../../app/common-components/Alert.jsx";
import PropTypes from "prop-types";
import ButtonComponent from "../../../../app/common-components/ButtonComponent.jsx";
import DiscardChanges from "../../../../app/common-components/DiscardChanges.jsx";
import Input from "../../../../app/common-components/form/input.jsx";
import MonthPicker from "../../../../app/common-components/MonthYearPicker/Monthpicker.jsx";
import Spinners from "../../../../app/common-components/Spinner.jsx";
import { convertEpochToISO8601, useCommonAlert } from "../../../../app/utilities/helpers.js";
import {
  saveBudget,
  setAlertError,
} from "./BudgetSlice.js";
import { formatDateString, getFYears, initialFormData, maxMinYears } from "./Constant.js";





const AddBudget = (props) => {
  const dispatch = useDispatch();
  const { common } = useSelector((state) => state);
  const { userName, userRole } = common.loggedUser;
  const [getFyList, setFyList] = useState([]);
  let { getCmdbId } = useSelector((state) => state.cmdbId);
  const { callCommonAlert, hideCommonAlert } = useCommonAlert();

  const { getDataBudget, getLoadingBudget, error, saveLoadingBudget, fyList } = useSelector(
    (state) => state.BudgetApi
  );
  const [state, setState] = useState({
    modalOpen: false,
    formData: { ...initialFormData },
    "FYearError": false,
    "FYearErrorMessage": "",
    "opexIDError": false,
    "opexIDErrorMessage": "",
    "opexBudgetError": false,
    "opexBudgetErrorMessage": "",
    "startDateError": false,
    "startDateErrorMessage": "",
    "endDateError": false,
    "endDateErrorMessage": "",
    "commentsError": false,
    "commentsErrorMessage": "",
    "effectiveDateError": false,
    "effectiveDateErrorMessage": "",
    conformationPop: false,
    addBodyBudget: false,
  });

  const [alert, setAlert] = useState({
    modelAlert: false,
    modelAlertType: "",
    modelAlertMessage: "",
  });

  useEffect(() => {
    if (error) {
      callCommonAlert("error", "Something went wrong. Please try again.");
      hideCommonAlert();
      dispatch(setAlertError());
    }
  }, [error]);
  useEffect(() => {
    if (fyList) {
      setFyList(fyList.map((ids, index) => ({
        value: ids,
        label: ids,
      })));
    }
  }, [fyList]);
  const callAlert = (type, msg) => {
    setAlert((alert) => ({
      ...alert,
      modelAlert: true,
      modelAlertType: type,
      modelAlertMessage: msg,
    }));
  };
  const hideAlert = () => {
    setTimeout(() => {
      setAlert((alert) => ({
        ...alert,
        modelAlert: false,
        modelAlertType: "",
        modelAlertMessage: "",
      }));
    }, 4000);
  };
  useEffect(() => {
    setState({
      formData: {
        id: getDataBudget?.id,
        FYear: getDataBudget?.financialYear,
        opexID: getDataBudget?.opexId,
        opexBudget: getDataBudget?.allocatedBudget,
        effectiveDate: getDataBudget?.effectiveDate,
        startDate: convertEpochToISO8601(getDataBudget?.budgetStartDate),
        endDate: convertEpochToISO8601(getDataBudget?.budgetEndDate),
        comments: getDataBudget?.comments
      },
    });
  }, [getDataBudget]);
  useEffect(() => {
    if (props.open) {
      clearForm();
    }
  }, [props.open]);
  const clearForm = () => {
    setState({ formData: { ...initialFormData } });
  };
  const validateForm = () => {
    let tmpFormFields = cloneDeep(state.formData);
    let formValidation = true;
    Object.keys(tmpFormFields).forEach((key) => {
      if (tmpFormFields[key] === "") {
        setState((state) => ({
          ...state,
          [`${key}Error`]: true,
          [`${key}ErrorMessage`]: `Field should not be empty`,
        }));
        formValidation = false;
      }
      if (/^0+(\.0*)?$|^\.0*$/.test(tmpFormFields?.opexBudget.toString())) {
        setState((state) => ({
          ...state,
          "opexBudgetError": true,
          "opexBudgetErrorMessage": "Please enter a valid amount",
        }));
        formValidation = false;
      }
    });
    return formValidation;
  };
  const NoSpace = (e) => {
    let value = e.target.value;

    // Prevent space at the start
    if (value.length === 0 && e.key === " ") {
      e.preventDefault(); // Prevents space input at the beginning
    }

    // Prevent consecutive spaces anywhere
    if (e.key === " " && value[value.length - 1] === " ") {
      e.preventDefault(); // Prevents consecutive spaces
    }
  };
  const handleOnChange = (name, selectedValue) => {
    if (state[`${name}Error`]) {
      setState((state) => ({
        ...state,
        [`${name}Error`]: false,
        [`${name}ErrorMessage`]: "",
      }));
    }
    if (name === "opexBudget" && selectedValue === "0") {
      setState((state) => ({
        ...state,
        "opexBudgetError": true,
        "opexBudgetErrorMessage": "Please enter a valid amount",
      }));
    }
    if (name === "FYear") {
      setState((state) => ({
        ...state,
        formData: {
          ...state.formData,
          effectiveDate: "",
        },
      }));
    }
    let value = selectedValue;
    if (Array.isArray(value)) {
      value = isEmpty(selectedValue) ? "" : selectedValue[0];
    }
    setState((state) => ({
      ...state,
      formData: {
        ...state.formData,
        [name]: Array.isArray(selectedValue) && selectedValue.length === 0 ? "" : selectedValue,
      },
      conformationPop: selectedValue === "" ? false : true,
    }));
  };
  const handleDate = (newValues, name) => {
    if (state[`${name}Error`]) {
      setState((state) => ({
        ...state,
        [`${name}Error`]: false,
        [`${name}ErrorMessage`]: "",
      }));
    }
    setState((prevState) => ({
      ...prevState,
      formData: {
        ...prevState.formData,
        [name]: newValues,
      },
      conformationPop: newValues ? true : false,
    }));
  };
  const saveFunction = () => {
    const validation = validateForm();
    if (validation) {
      const { id, FYear, opexID, opexBudget, effectiveDate, startDate, endDate, comments } =
        state.formData;
      const Payload = {
        cmdbId: getCmdbId,
        payload: {
          id: id === undefined ? 0 : id,
          financialYear: FYear,
          opexId: opexID,
          allocatedBudget: Number(opexBudget),
          effectiveDate: effectiveDate ? formatDateString(effectiveDate) : "",
          // budgetStartDate:convertToEpoch(startDate)*1000,
          // budgetEndDate:convertToEpoch(endDate)*1000,
          // comments:comments
        },
      };
      dispatch(saveBudget(Payload)).then((data) => {
        if (data?.payload?.statusCodeValue !== 400) {
          props.handleClose();
        }
        props.alertmsg(data.payload);
      });

    }
  };
  const addmodalCancelBudget = () => {
    setState((state) => ({
      ...state,
      addBodyBudget: true,
    }));
  };
  const addBodyCloseBudget = () => {
    setState({
      ...state,
      addBodyBudget: false,
    });
  };
  const addBodyCancelBudget = () => {
    return (
      <>
        <DiscardChanges title={props.currentAction === "Edit" ? 'edit' : 'add'} discardClick={cancelFuncton} cancelClick={addBodyCloseBudget} />
      </>
    );
  };



  const cancelFuncton = () => {
    props.handleClose();
    setState((state) => ({
      ...state,
      conformationPop: false,
    }));
  };
  const dateChange = (date) => {
    const selectedDate = new Date(date);
    const currentDate = new Date();
    const selectedDateOnly = new Date(
      selectedDate.getFullYear(),
      selectedDate.getMonth(),
      selectedDate.getDate()
    );
    const currentDateOnly = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate()
    );
    if (selectedDateOnly < currentDateOnly) {

      setAlert((alert) => ({
        ...alert,
        modelAlert: true,
        modelAlertType: "warning",
        modelAlertMessage:
          "The date you have selected is in the past. Please choose a current or future date from the calendar.",
      }));
      hideAlert();
    } else {
      if (isNaN(selectedDate.getTime())) {
        // invalid date
        return 0;
      } else {
        return date;
      }
    }
  };

  function allowDecimal(e) {
    const code = e.charCode || e.keyCode;
    const inputValue = e.target.value;

    // Allow numeric characters (0-9) and a decimal point (.)
    if (
      !(code >= 48 && code <= 57) && // Numbers 0-9
      code !== 46 && // Decimal point (.)
      code !== 8 // Backspace
    ) {
      e.preventDefault();
      return;
    }

    // Prevent more than one decimal point
    if (code === 46 && inputValue.includes(".")) {
      e.preventDefault();
      return;
    }

    // Prevent entering more than two decimal places
    const decimalIndex = inputValue.indexOf(".");
    if (decimalIndex !== -1 && inputValue.length - decimalIndex > 2 && code >= 48 && code <= 57) {
      e.preventDefault();
      return;
    }
  }
  function extractYears(fiscalYear) {
    let startDate = "03-01";
    let endDate = "04-30";
    if (fiscalYear) {
      const years = fiscalYear.replace("FY ", "").split("-");
      const startYear = parseInt(years[0], 10);
      const endYear = startYear + 1;
      startDate = startYear + "-" + startDate;
      endDate = endYear + "-" + endDate;
      return { startDate, endDate };
    }
  }
  const handlePaste = (e) => {
    const pastedData = (e.clipboardData || window.clipboardData).getData('text');
    for (let i = 0; i < pastedData.length; i++) {
      const code = pastedData.charCodeAt(i);
      if (!(code >= 48 && code <= 57)) {
        e.preventDefault();
        return;
      }
    }
  };
  const FYears = getFYears(userRole);
  return (
    <>
      <div>
        <h4 className="actionDescription mb-3">{props.currentAction === "Edit" ? "Update Budget Details" : "Add Budget Details"}</h4>
        {getLoadingBudget || saveLoadingBudget ? (
          <Spinners />
        ) : (
          <Row className="m-0">
            <Col xl={6} lg={6} md={12} sm={12} xs={12} className="p-0">
              <div className="mb-3">
                <CustomSelectDropDown
                  key={1}
                  containerClassName="frmgroup validate default-input col-md-12"
                  labelName={"Financial Year*"}
                  isSearchable={false}
                  placeholder={"Select Financial Year"}
                  options={FYears}
                  isDisabled={props.currentAction === "Edit" ? true : false}
                  value={FYears?.find(
                    (year) => year.value === state.formData.FYear
                  )}
                  name={"Financial Year"}
                  error={state["FYearError"]}
                  errorMessage={state["FYearErrorMessage"]}
                  onChange={(e) => {
                    handleOnChange("FYear", e.value);
                  }}
                />
              </div>
            </Col>
            <Col xl={6} lg={6} md={12} sm={12} xs={12}>
              <div className="mb-3">
                <lable className="form-label">Effective Date<span className="RedHighlight">*</span></lable>
                <MonthPicker
                  onChange={(newValues) => handleDate(newValues, "effectiveDate")}
                  format={"MM/YYYY"}
                  labelClass={"date-picker"}
                  value={state.formData.effectiveDate}
                  error={state["effectiveDateError"]}
                  errorMessage={state["effectiveDateErrorMessage"]}
                  minDate={maxMinYears(state.formData.FYear)?.minDate}
                  maxDate={maxMinYears(state.formData.FYear)?.maxDate}
                />
              </div>
            </Col>
            <Col xl={6} lg={6} md={12} sm={12} xs={12}>
              <div className="mb-3">
                <Input
                  label={"Opex ID*"}
                  type='text'
                  list="serverlistdatalist"
                  name={"opexID"}
                  id="opexID"
                  value={state.formData.opexID}
                  className="form-control"
                  placeholder="Enter Opex ID"
                  maxLength={20}
                  error={state["opexIDError"]}
                  errorMessage={state["opexIDErrorMessage"]}
                  containerClassName={"frmgroup validate default-input col-12 p-0"}
                  onKeyPress={(e) => NoSpace(e)}
                  onChange={(e) => {
                    handleOnChange('opexID', e.target.value);

                  }}
                />
              </div>
            </Col>
            <Col xl={6} lg={6} md={12} sm={12} xs={12}>
              <div className="mb-3">
                <Input
                  label={"Allocated Budget (SGD)*"}
                  type='text'
                  list="serverlistdatalist"
                  name={"opexBudget"}
                  id="opexBudget"
                  value={state.formData.opexBudget}
                  className="form-control"
                  placeholder="Enter Allocated Budget"
                  maxLength={20}
                  error={state["opexBudgetError"]}
                  errorMessage={state["opexBudgetErrorMessage"]}
                  containerClassName={"frmgroup validate default-input col-12 p-0"}
                  onKeyPress={(e) => allowDecimal(e)}
                  onPaste={(e) => { handlePaste(e); }}
                  // onChange={(e) =>{
                  //  handleOnChange('opexBudget',e.target.value);
                  // }}
                  onChange={(e) => {
                    const value = e.target.value;
                    // if (!value.startsWith('0') || value === '') {
                    handleOnChange('opexBudget', value);
                    // }
                  }}
                />
              </div>
            </Col>
            {/* <Col xl={6} lg={6} md={12} sm={12} xs={12}>
            <div className="mb-3">
              <Input
              label={"Budget Start Date*"}
                type="date"
                className="form-control"
                name={"startDate"}
                disabled={props.currentAction === "Edit" ?true:false}
                 minDate={extractYears(state.formData.FYear)?.startDate}
                maxDate={extractYears(state.formData.FYear)?.endDate}
                containerClassName={"frmgroup validate default-input col-12 p-0"}
                value={
                  state.formData.startDate
                    ? state.formData.startDate.toString().substring(0, 10)
                    : ""
                }
                error={state["startDateError"]}
                errorMessage={state["startDateErrorMessage"]}
                onChange={(e) =>{
                  handleOnChange('startDate',dateChange(e.target.value));
                }}
              />
            </div>
          </Col>
          <Col xl={6} lg={6} md={12} sm={12} xs={12}>
            <div className="mb-3">
              <Input
              label={"Budget End Date*"}
                type="date"
                className="form-control"
                name={"endDate"}
                disabled={props.currentAction === "Edit" ?true:false}
                minDate={extractYears(state.formData.FYear)?.startDate}
                maxDate={extractYears(state.formData.FYear)?.endDate}
                containerClassName={"frmgroup validate default-input col-12 p-0"}
                value={
                  state.formData.endDate
                    ? state.formData.endDate.toString().substring(0, 10)
                    : ""
                }
                error={state["endDateError"]}
                errorMessage={state["endDateErrorMessage"]}
                onChange={(e) =>{
                  handleOnChange('endDate',dateChange(e.target.value));
                }}
              />
            </div>
          </Col>
          <Col xl={12} lg={12} md={12} sm={12} xs={12}>
          <div className="confingformcol appGroupWidth appConfigAdd">
            <label>Comments<span className="RedHighlight">*</span></label>
            <div className="error errorAlighn">{state["commentsErrorMessage"]}</div>
            <TextArea
              type={"text"}
              placeholder={"Enter your Comments here"}
              rows="7"
              name={"comments"}
              className={`${state["commentsError"]?'errorBorder':''}`}
              error={state["commentsError"]}
              errorMessage={state["commentsErrorMessage"]}
              value={state.formData.comments}
              onChange={(e) =>{
                handleOnChange('comments',e.target.value);
              }}
            />
            </div>
          </Col> */}
            <Col>
              <div className="btn-container">
                {/* <CommonBtn */}
                <ButtonComponent
                  text="Cancel"
                  className="cancelBtnStyle btn-primary py-2 cancelBudget"
                  onClick={() => {
                    if (state.conformationPop) {
                      addmodalCancelBudget();
                    } else {
                      cancelFuncton();
                    }
                  }}
                  id="BudgetCancel_id"
                />
                <ButtonComponent text="Save" onClick={() => { saveFunction(); }} id="BudgetSave_id" />
                {/* <AlertBox
                alert={alert.modelAlert}
                type={alert.modelAlertType}
                message={alert.modelAlertMessage}
              /> */}
                <CustomModal
                  modalOpen={state.addBodyBudget}
                  modalBody={addBodyCancelBudget}
                  modalHide={addmodalCancelBudget}
                  closeBtn={true}
                  closeBtnFuc={addBodyCloseBudget}
                />
              </div>
            </Col>
          </Row>
        )}
      </div>
    </>
  );
};

AddBudget.propTypes = {
  open: PropTypes.bool.isRequired,
  currentAction: PropTypes.string.isRequired,
  reloadPayload: PropTypes.shape({
    cmdbId: PropTypes.number.isRequired,
    pageNumber: PropTypes.number.isRequired,
    itemsPerPage: PropTypes.number.isRequired,
    payload: PropTypes.shape({
      keyword: PropTypes.string.isRequired
    }).isRequired
  }).isRequired
};
export default memo(AddBudget);